// extracted by mini-css-extract-plugin
export default {"container":"Hotspot_container__bkBGP","ring":"Hotspot_ring__dqsNb","stop-pulsate":"Hotspot_stop-pulsate__EfVH5","circle":"Hotspot_circle__uugBz","pulsate":"Hotspot_pulsate__DtSDd"};